const config = {
  "projectId": process.env.PROJECT_ID,
  "prodHost": process.env.PROD_HOST,
  "androidAppLink": process.env.ANDROID_APP_LINK,
  "iosAppLink": process.env.IOS_APP_LINK,
  "analyticsId": process.env.ANALYTICS_ID,
  "language": process.env.LANGUAGE,
};

export default config;